import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  input,
  output,
  signal,
  viewChild
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'coin-chat-dialog-footer',
  templateUrl: './chat-dialog-footer.component.html',
  styleUrl: './chat-dialog-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, ReactiveFormsModule, FormsModule, TranslateModule]
})
export class ChatDialogFooterComponent implements AfterViewInit {
  textarea = viewChild<ElementRef<HTMLInputElement>>('textarea');
  disableSendButton = input<boolean>(false);
  disableCleanButton = input<boolean>(false);
  sendMessage = output<string>();
  cleanMessage = output<void>();

  isDisabledSendButton = computed(() => this.disableSendButton() || this.message().trim().length === 0);
  message = signal<string>('');

  setMessage(content: string) {
    this.message.set(content);
  }

  ngAfterViewInit(): void {
    this.textarea()?.nativeElement.focus();
  }

  handleSendMessage() {
    if (!this.isDisabledSendButton()) {
      this.sendMessage.emit(this.message());
      this.setMessage('');
    }
  }

  handleTextareaKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault(); // prevent newline
      this.handleSendMessage();
    }
  }
}
